import { Injectable, inject } from '@angular/core';
import {ApplicationInsights} from '@microsoft/applicationinsights-web';
import {ActivatedRouteSnapshot, ResolveEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {environment} from 'src/environments/environment';

@Injectable()
export class ApplicationInsightsService {
    private readonly router = inject(Router);

    private readonly appInsights: ApplicationInsights;

    constructor() {

        if (environment.instrumentationKey) {
            this.appInsights = new ApplicationInsights({
                config: {
                    instrumentationKey: environment.instrumentationKey
                }
            });

            this.appInsights.loadAppInsights();
            const result = this.router.events.pipe(filter(event => event instanceof ResolveEnd))
                .subscribe({
                    next: (event: ResolveEnd) => {
                        const activatedComponent = this.getActivatedComponent(event.state.root);
                        if (activatedComponent) {
                            this.logPageView(`${activatedComponent.name} ${this.getRouteTemplate(event.state.root)}`, event.urlAfterRedirects);
                        }
                    }, complete: () => {
                        if (result) {
                            result.unsubscribe();
                        }
                    }
                });
        }

    }

    setUserId(userId: string) {
        if (environment.instrumentationKey) {
            this.appInsights.setAuthenticatedUserContext(userId);
        }
    }

    clearUserId() {
        if (environment.instrumentationKey) {
            this.appInsights.clearAuthenticatedUserContext();
        }
    }

    logPageView(name?: string, uri?: string) {
        this.appInsights.trackPageView({name, uri});
    }

    trackException(name: string, error: string, stack?: string){
        const err = new Error(error);
        err.name = name;
        err.stack = stack;
        this.appInsights.trackException({exception: err});
    }

    private getActivatedComponent(snapshot: ActivatedRouteSnapshot) {
        if (snapshot.firstChild) {
            return this.getActivatedComponent(snapshot.firstChild);
        }

        return snapshot.component;
    }

    private getRouteTemplate(snapshot: ActivatedRouteSnapshot): string {
        let path = '';
        if (snapshot.routeConfig) {
            path += snapshot.routeConfig.path;
        }

        if (snapshot.firstChild) {
            return path + this.getRouteTemplate(snapshot.firstChild);
        }

        return path;
    }
}
